import fa from 'locales/fa.json';
import Link from 'next/link';
import React from 'react';
import { AllPageRoute } from 'services/routes';
import { SAllLink } from './style';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { HomeType } from 'types/course.type';
import TeacherAvatar from 'components/Common/TeacherAvatar';

const Teachers: React.FC<{ data: HomeType }> = ({ data }) => {
  return (
    <div className="center flex-col overflow-hidden">
      <h2 className="font-bold text-[24px] md:text-[27px] mb-[30px]">
        {fa.global.teachers}
      </h2>

      <div className="flex flex-wrap items-center justify-center">
        {data.teachers?.map((teacher) => {
          return <TeacherAvatar teacher={teacher} key={teacher.nickname} />;
        })}
      </div>

      <Link href={AllPageRoute('teachers')} passHref>
        <SAllLink className="text-[16px] text-blue-1 cursor-pointer mt-[20px]">
          {fa.landing.seeAllTeachers} <ArrowLeftOutlined />
        </SAllLink>
      </Link>
    </div>
  );
};

export default Teachers;
